import DocumentGridItem from './DocumentGridItem'

export default DocumentGridItem
